import React, { useEffect, useState, useMemo } from "react"
import { Col, Row, Card, CardBody, CardImg, Input } from "reactstrap"
import Spinners from "components/Common/Spinner"
import { useDispatch, useSelector } from "react-redux"
import {
  getDivisionStart,
  getStudentStart,
  getStudentReset,
} from "store/Common/Actions"
import { useNavigate } from "react-router-dom"
import "react-image-crop/dist/ReactCrop.css"
import { replaceS3Url } from "components/Common/ReplaceS3Url"
import { debounce } from "lodash"

const Home = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [searchText, setSearchText] = useState("")
  const [isOrder, setOrder] = useState(null)
  const [debouncedSearch, setDebouncedSearch] = useState("")
  const acadid = localStorage.getItem("acad_id")
  const div_id = localStorage.getItem("div_id")
  const sort_order = localStorage.getItem("sortOrder") || "default"

  const { division, studentList, isUploaded } = useSelector(
    state => state.CommonReducer
  )

  const [sortedStudents, setSortedStudents] = useState([])

  useEffect(() => {
    if (acadid && division.length === 0) {
      dispatch(getDivisionStart({ acad_id: acadid }))
    }
  }, [acadid, division.length, dispatch])

  useEffect(() => {
    if (div_id || isUploaded) {
      dispatch(getStudentStart({ classdivid: parseInt(div_id) }))
    }
  }, [div_id, isUploaded])

  // useEffect(() => {
  //   dispatch(getStudentReset())
  // }, [])

  useEffect(() => {
    if (!studentList || studentList.length === 0) {
      setSortedStudents([])
      return
    }

    let sortedArray = [...studentList]
    switch (sort_order) {
      case "First Name":
        sortedArray.sort(
          (a, b) =>
            a.student_name
              .split(" ")[1]
              ?.localeCompare(b.student_name.split(" ")[1]) || 0
        )
        break
      case "Last Name":
        sortedArray.sort(
          (a, b) =>
            a.student_name
              .split(" ")[0]
              ?.localeCompare(b.student_name.split(" ")[0]) || 0
        )
        break
      case "user_id":
        sortedArray.sort((a, b) => a.roll_no - b.roll_no)
        break
      case "gender":
        sortedArray.sort((a, b) => a.gender?.localeCompare(b.gender))
        break
      default:
        break
    }
    setSortedStudents(sortedArray)
  }, [studentList, sort_order])

  const handleSortChange = e => {
    const value = e.target.value
    setOrder(value)
    localStorage.setItem("sortOrder", value)
  }

  const debouncedChangeHandler = useMemo(
    () =>
      debounce(value => {
        setDebouncedSearch(value)
      }, 300),
    []
  )

  useEffect(() => {
    debouncedChangeHandler(searchText)
  }, [searchText, debouncedChangeHandler])

  const filterData = sortedStudents.filter(student =>
    student.student_name.toLowerCase().includes(debouncedSearch.toLowerCase())
  )

  const handleFileChange = (e, student) => {
    const selectedFile = e.target.files[0]
    if (selectedFile) {
      const imageUrl = URL.createObjectURL(selectedFile)
      navigate("/crop", {
        state: {
          imageUrl,
          Uid: student.user_id,
          div: div_id,
        },
      })
    }
  }

  return (
    <Row className="mt-5 py-4">
      <Card>
        <CardBody className="p-2">
          <div className="container-fluid">
            <h1 className="text-center mt-2 fs-4">Student Profile Pic</h1>

            <Row>
              <Col xl="6" md="6" sm="3" className="mt-2">
                <select
                  className="form-select"
                  value={div_id}
                  onChange={e => localStorage.setItem("div_id", e.target.value)}
                >
                  <option>Select Class</option>
                  {division.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.div_name}
                    </option>
                  ))}
                </select>
              </Col>

              <Col xl="6" md="6" sm="3" className="mt-3 mb-3">
                <select
                  className="form-select"
                  value={sort_order}
                  onChange={handleSortChange}
                >
                  <option value="default">Select Sort Order</option>
                  <option value="user_id">Roll No</option>
                  <option value="gender">Gender</option>
                </select>
              </Col>

              <Col>
                <Input
                  name="searchtext"
                  type="text"
                  placeholder="Search by student"
                  className="form-control"
                  value={searchText}
                  onChange={e => setSearchText(e.target.value)}
                />
              </Col>
            </Row>

            {sortedStudents.length === 0 ? (
              <></>
            ) : (
              <Col xl="6" md="6" sm="12" className="mt-2">
                {filterData.map((item, idx) => (
                  <Card key={idx} className="p-4 position-relative">
                    <CardImg
                      src={
                        replaceS3Url(item.avatar || "") ||
                        "https://ocisa.prisms.in/images/dashboard/student.png"
                      }
                      alt="Profile"
                      className="mb-3"
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />

                    <Input
                      type="file"
                      accept="image/png, image/jpeg, image/jpg"
                      style={{ display: "none" }}
                      id={`file-input-${item.user_id}`}
                      onChange={e => handleFileChange(e, item)}
                    />

                    <label
                      htmlFor={`file-input-${item.user_id}`}
                      style={{
                        position: "absolute",
                        bottom: 55,
                        right: 5,
                        backgroundColor: "#007bff",
                        color: "white",
                        padding: "8px",
                        borderRadius: "20%",
                        cursor: "pointer",
                        border: "2px solid white",
                      }}
                    >
                      <i
                        className="fa fa-camera"
                        style={{ fontSize: "18px" }}
                      />
                    </label>

                    <span className="fw-bold">{item.student_name}</span>
                    <span className="fw-bold">
                      {isOrder === "user_id"
                        ? item.roll_no !== null && item.roll_no !== 0
                          ? item.roll_no
                          : ""
                        : item.gender?.toLowerCase() === "female"
                        ? "(F)"
                        : "(M)"}
                    </span>
                  </Card>
                ))}
              </Col>
            )}
          </div>
        </CardBody>
      </Card>
    </Row>
  )
}

export default Home
